export default {"src":"/_next/static/media/deco_ticketz_benefit_support.67a38d89.svg","height":32,"width":30,"blurWidth":0,"blurHeight":0};